import {EntityDataStatus, EntityModel} from "@fedeltapointofsale/data-client";
import {PeriodScheduleData, PeriodScheduleRuleData} from "./period-schedule.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PeriodScheduleEntityModel extends EntityModel<PeriodScheduleData> {

    constructor(injector: Injector) {
        super(injector, PeriodScheduleData);
    }

    protected override onAfterLoadEntity(): void {
        this.data.ednStatus = EntityDataStatus.LOADING;
        this.data.overallRule.initSelectedOptions();
        this.data.activeRules.forEach((rule: PeriodScheduleRuleData) => rule.initSelectedOptions());
        this.data.inactiveRules.forEach((rule: PeriodScheduleRuleData) => rule.initSelectedOptions());
        this.data.ednStatus = EntityDataStatus.LOADED;
    }

    protected override onBeforeSaveEntity(entityData: PeriodScheduleData) {
        this.data.overallRule.clearUnselectedCriteria();
        this.data.activeRules.forEach((rule: PeriodScheduleRuleData) => rule.clearUnselectedCriteria());
        this.data.inactiveRules.forEach((rule: PeriodScheduleRuleData) => rule.clearUnselectedCriteria());
        this.data.activeRules = this.data.activeRules.filter((rule: PeriodScheduleRuleData) => rule.hasCriteria);
        this.data.inactiveRules = this.data.inactiveRules.filter((rule: PeriodScheduleRuleData) => rule.hasCriteria);
        if (!this.data.venueStatusLabel) {
            this.data.venueStatusLabel = null;
        }
    }
}
